import { keyWithType } from "./keyWithType";

export const keysWithTitles = <T>(
  inputArr: { [key: string]: string },
  keyPrefix = "",
  keyPostfix = "",
  keyTitlePrefix = "",
  keyTitlePostfix = "",
) => {
  const titleArray = Object.entries(inputArr).map((item) => {
    const key = keyWithType<string>(item[0], keyPrefix, keyPostfix);
    const keyTitle = keyWithType<string>(
      item[1],
      keyTitlePrefix,
      keyTitlePostfix,
    );
    return [key, keyTitle];
  });
  return Object.fromEntries(titleArray) as T;
};
